import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

export const sidebarSettings = createSlice({
  name: 'sidebarSettings',
  initialState: {
    resizeDelta: 0,
    collapsed: false,
    pinDisabled: false,
    autoCollapseDisabled: false,
  },
  reducers: {
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.collapsed = action.payload
    },
    setResizeDelta: (state, action: PayloadAction<number>) => {
      state.resizeDelta = action.payload
    },
    setAutoCollapseDisabled: (state, action: PayloadAction<boolean>) => {
      state.autoCollapseDisabled = action.payload
    },
    toggleCollapseSidebar: state => {
      state.collapsed = !state.collapsed
    },
    disableSidebarPin: (state, action: PayloadAction<boolean>) => {
      const pinned = action.payload
      state.pinDisabled = true
      if (pinned) {
        state.collapsed = true
      }
    },
    enableSidebarPin: (state, action: PayloadAction<boolean>) => {
      const pinned = action.payload
      state.pinDisabled = false
      if (pinned) {
        state.collapsed = false
      }
    },
  },
})
